import React from 'react';
import { observer } from 'mobx-react';
import { useHistory, useLocation } from 'react-router-dom';

import { AuthSecurity } from 'services/auth';

import config from 'config';
import Router from 'app-router';
import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import AccessDeniedPage from 'pages/Errors/AccessDenied';

const App: React.FC =  observer(() =>
{
  const { authStore } = useStore();
  const history = useHistory();
  const location = useLocation();

  const navigate = (url: string) => history.push(url);

  // Automatically scroll to top on every page change.
  // See https://v5.reactrouter.com/web/guides/scroll-restoration
  React.useLayoutEffect(() =>
  {
    if ('scrollRestoration' in window.history)
    {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' as ScrollBehavior,
    });
  }, [location.pathname]);

  return (
    <AuthSecurity authStore={authStore}
                  config={
                    {
                      openIdConfiguration:
                      {
                        ...config.okta,
                        loginCallbackUrl: paths.buildAbsolutePath(paths.buildOpenIdLoginPath()),
                      },
                      onAuthRequired: () =>
                      {
                        console.log(location.pathname)
                        if (!paths.isLoginPath(location.pathname))
                        {
                          authStore.setReturnUrl(location.pathname);
                          window.location.replace(paths.buildLoginPath());
                        }
                      },
                      onAuthenticated: () =>
                      {
                        navigate(authStore.returnUrl ?? paths.buildDashboardPath());
                      },
                    }
                  }
                  accessDenied={<AccessDeniedPage />}
                  accessDeniedUrl={paths.buildAccessDeniedPath()}
                  redirectToAccessDeniedUrl={() => navigate(paths.buildAccessDeniedPath())} >
      <Router />
    </AuthSecurity>
  );
});

export default App;
